import { useState } from 'react';

export const useJournalModal = (refreshCallback: () => void) => {
  const [isJournalModalOpen, setIsJournalModalOpen] = useState(false);
  const [selectedJournalEntry, setSelectedJournalEntry] = useState<any | null>(null);

  const handleJournalEntryClick = (entry: any) => {
    setSelectedJournalEntry(entry);
    setIsJournalModalOpen(true);
  };

  const handleJournalEntryUpdated = () => {
    setIsJournalModalOpen(false);
    setSelectedJournalEntry(null);
    refreshCallback();
  };

  const handleCloseJournal = () => {
    setIsJournalModalOpen(false);
    setSelectedJournalEntry(null);
  };

  return {
    isJournalModalOpen,
    selectedJournalEntry,
    handleJournalEntryClick,
    handleJournalEntryUpdated,
    handleCloseJournal,
  };
};
